<template>
  <div class="ticketInset">
    <template v-if="isMessage">
      <div :class="{ side_line: true, step: !isSuccess }"></div>
      <div class="side_wrap" v-if="!isSuccess">
        <h2>{{ title }}</h2>
        <p class="des">我们最快2小时内联系您</p>
        <el-form ref="form" :model="form" :rules="rules">
          <el-form-item label="咨询内容" prop="content">
            <el-input placeholder="请输入咨询内容" v-model="form.content" type="textarea" :rows="2" resize="none"
              maxlength="1000">
            </el-input>
          </el-form-item>
          <el-form-item label="您的称呼" prop="customer">
            <el-input placeholder="请输入您的称呼" v-model="form.customer" maxlength="25"></el-input>
          </el-form-item>
          <el-form-item class="side_tab">
            <span :class="{ active: tab === 'phone' }" @click="handleTab('phone')">手机号码</span>
            <span :class="{ active: tab === 'email' }" @click="handleTab('email')">电子邮箱</span>
          </el-form-item>
          <el-form-item label="   " v-if="tab === 'phone'" prop="phone" style="margin-bottom: 0 !important">
            <el-input placeholder="请输入您的手机号码" v-model="form.phone" maxlength="50" ref="phone" :disabled="disablePhone"
              @input="handleInputEmail">
              <template slot="prepend">+86</template>
            </el-input>
          </el-form-item>
          <el-form-item label="   " v-if="tab === 'email'" prop="email" style="margin-bottom: 0 !important">
            <el-input placeholder="请输入您的电子邮箱" :disabled="disableMail" v-model="form.email" maxlength="80" ref="email"
              @input="handleInputEmail">
            </el-input>
          </el-form-item>
          <el-form-item label="   " class="side_tips" v-if="!isLogin">
            <p>*自动注册会员，在线查看咨询进度</p>
          </el-form-item>
          <el-form-item label="所在城市" prop="provice">
            <el-select placeholder="请选择所在省份或地区" v-model="form.provice" filterable style="width: 100%">
              <el-option v-for="item in provice" :key="item.orgName" :label="item.orgName" :value="item.orgName">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <a class="button" @click="handleSubmit">立即咨询</a>
            <div style="opacity: 0; height: 0">
              <button id="TencentCaptcha" data-appid="193600977" data-cbfn="callback" type="button">
                验证
              </button>
            </div>
          </el-form-item>
          <el-form-item class="side_protocol">
            <el-checkbox v-model="dialogReg.approve">
              <template v-if="contact_approve_show">提交后自动注册会员，获取后续信息<br /></template>
              我已阅读并同意
              <template v-if="contact_approve_show"><a @click="dialogReg.visible = true">注册条款</a>及</template>
              <a href="https://www.sgsgroup.com.cn/zh-cn/privacy-at-sgs" target="_blank">隐私政策</a>
            </el-checkbox>
          </el-form-item>
        </el-form>
      </div>
      <div class="side_success" v-else>
        <img :src="email" class="side_success_email" />
        <p class="side_success_title">发送成功</p>
        <p class="side_success_des">您的咨询信息已收到，我们将尽快与您联系！</p>
        <p class="side_success_userinfo" v-if="type === 1">
          用户账号：{{ form.phone || form.email }}
        </p>
        <p v-if="type === 1" class="side_success_tips">
          已为您注册SGS在线商城会员<br />可使用账号快捷登录
        </p>
        <p v-if="type === 1 || type === 2 || type === 3" class="side_success_tips">
          到“<a :href="'/quote/list'">我的咨询</a>”查看咨询进度
        </p>
        <p v-if="type === 1 || type === 2 || type === 3" class="side_success_countdown">
          <i id="countdown">{{ countdownTime }}</i>秒后自动跳转
        </p>
        <div class="side_success_ERcode" v-if="type === 4">
          <img :src="ERcode" />
          <p>扫码关注SGS官方微信公众号， 回复“<i>0</i>”赢惊喜礼品！</p>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="side_line"></div>
      <div class="side_step">
        <h2>专业工程师 在线服务</h2>
        <h2>2小时获取 测试方案</h2>
        <a class="button" target="_blank" :href="memberUrl + '/questionnaire/step1'">开始询价</a>
        <div class="side_step_gif">
          <span>服务流程</span>
          <a target="_blank" :href="memberUrl + '/questionnaire/step1'">
            <img :src="step" />
          </a>
        </div>
        <a :href="level1Path + '/oiq'" target="_blank" class="more">了解更多</a>
      </div>
    </template>
    <!-- 发送验证码 -->
    <login-verify-code ref="loginVerifyCode" :env="env" :captcha-app-id="captchaAppId" v-model="dialogCode.visible"
      :captcha-show="!!form.phone" :number="form.phone || form.email" :data="pageInfo"
      :handle-submit="handleSubmitService" :verify-params="verifyParams" />
    <register-terms v-if="dialogReg.visible" @setTipsVisible="setTipsVisible"></register-terms>
    <slot></slot>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { host } from "src/config";
import { qryCity, getCode, createTicketByPhone } from "./../../request/portal";
import RegisterTerms from "./../loginMerge/RegisterTerms";
import LoginVerifyCode from "../loginVerifyCode/index.vue";

export default {
  name: "TicketInset",
  props: {
    captchaAppId: {
      type: String,
      default: ''
    },
    env: {
      type: String,
      default: "local",
    },
    userInfo: {
      type: Object,
      default: () => { },
    },
    defaultForm: {
      type: Object,
      default: null
    },
    memberUrl: {
      type: String,
      default: ''
    },
    level1Path: {
      type: String,
      default: 'https://www.sgsonline.com.cn'
    },
    title: {
      type: String,
      default: '需要更多信息？'
    }
  },
  components: {
    RegisterTerms,
    LoginVerifyCode
  },
  data() {
    return {
      verifyParams: {
        projectName: 'TIC_TEMPLATE',
        verifyType: 2
      },
      host: host(this.env),
      ERcode: require("./../../assets/images/ticketInset/ERcode.png"),
      email: require("./../../assets/images/ticketInset/email.png"),
      step: require("./../../assets/images/ticketInset/step.gif"),
      isSuccess: false,
      approve: false,
      contact_approve_show: true,
      dialogVisibleReg: false,
      isLogin: false,
      tab: "phone",
      type: 0,
      countdownTime: 5,
      countdownTimer: null,
      form: {
        type: "业务咨询",
        trade: "",
        tradeName: "其他",
        service: "",
        serviceName: "其他",
        productId: "",
        productName: "",
        company: "",
        provice: "",
        content: "",
        customer: "",
        email: "",
        phone: "",
        imageCode: "",
        frontUrl: window.location.href,
        destCountry: "",
        verifyCode: "",
        osType: "pc",
        regSource: "",
        regMode: "USER_REG",
        regFrom: window.location.href
      },
      provice: [],
      dialogReg: { visible: false },
      rules: {
        provice: [{ required: true, message: "*请选择所在城市" }],
        content: [{ required: true, message: "*请输入咨询内容" }],
        customer: [{ required: true, message: "*请输入您的称呼" }],
        // email: [{ validator: validatorEmail }],
        // phone: [{ validator: validatorUserPhone }],
      },
      isMessage: true,
      /* 验证码相关 */
      dialogCode: {
        visible: false,
        seconds: 59,
        timer: null,
      },
      // 弹窗文案，融合手机以及邮箱
      pageInfo: {
        title: "验证手机号",
        sendModel: "已发送到手机号：+86",
        prepend: "手机验证码",
      },
      appendToBody: true,
      disableMail: false,
      disablePhone: false,
    };
  },
  methods: {
    handleTab(val) {
      this.tab = val;
    },
    handleInputEmail() {
      // if (!this.isLogin) {
      //   if (this.form.email && !this.form.phone) {
      //     this.contact_approve_show = false;
      //   } else {
      //     this.contact_approve_show = true;
      //   }
      // }
    },
    // 提交留言表单
    handleSubmit() {
      if (this.verifyPhoneAndMail()) {
        const formRef = this.$refs.form;
        formRef.validate((valid) => {
          if (valid) {
            // 隐私条款勾选状态
            if (this.dialogReg.approve) {
              // 登录直接提交
              if (this.isLogin) {
                createTicketByPhone(this.form, this.host.nodeUrl).then(
                  (res) => {
                    this.submitResult(res);
                  }
                );
              } else {
                this.dialogCode.visible = true
                if (this.form.phone) {
                  this.pageInfo = {
                    title: "验证手机号",
                    sendModel: "已发送到手机号：+86",
                    prepend: "手机验证码",
                  };
                } else {
                  this.pageInfo = {
                    title: "验证邮箱",
                    sendModel: "已发送到邮箱",
                    prepend: "邮箱验证码",
                  };
                }
              }
            } else {
              this.$message.error("请先阅读隐私政策并选择是否同意");
            }
          }
        });
      }
    },
    // 验证手机和邮箱
    verifyPhoneAndMail() {
      const regMail =
        /^[a-zA-Z0-9_.-]+@\w+([-.][A-Za-z0-9]+)*\.\w+([-.][A-Za-z0-9]+)*$/;
      const regPhone = /^[1][2,3,4,5,6,7,8,9][0-9]{9}$/;
      let flag = false;
      if (!this.form.phone && !this.form.email) {
        if (this.tab === "phone") {
          this.$message.error("请输入手机号");
          this.tab = "phone";
        } else {
          this.$message.error("请输入邮箱地址");
          this.tab = "email";
        }
      } else if (this.form.phone && !this.form.email) {
        if (!regPhone.test(this.form.phone)) {
          this.$message.error("请输入正确的手机号");
          this.tab = "phone";
        } else {
          this.tab = "phone";
          flag = true;
        }
      } else if (!this.form.phone && this.form.email) {
        if (!regMail.test(this.form.email)) {
          this.$message.error("请输入正确的邮箱地址");
          this.tab = "email";
        } else {
          this.tab = "email";
          flag = true;
        }
      } else {
        if (!regPhone.test(this.form.phone)) {
          this.$message.error("请输入正确的手机号");
          this.tab = "phone";
        } else if (!regMail.test(this.form.email)) {
          this.$message.error("请输入正确的邮箱地址");
          this.tab = "email";
        } else {
          flag = true;
        }
      }
      return flag;
    },
    // 提交数据到服务端
    handleSubmitService(loginRef) {
      this.form.verifyMode = this.form.phone ? 'phone' : 'email';
      this.form.verifyCode = loginRef.verifyCode
      if (this.form.verifyCode) {
        loginRef.loading = true
        createTicketByPhone(this.form, this.host.nodeUrl).then((res) => {
          loginRef.loading = false
          this.submitResult(res);
        }).catch(e => {
          loginRef.loading = false
        })
      } else {
        this.$message.error("请输入验证码");
      }
    },
    // 提交数据之后的返回处理
    // todo 正式接入后注意修改重定向地址
    submitResult(val) {
      if (val.resultCode === "0") {
        if (val.data.isReg === 1) {
          this.type = 1;
        } else if (val.data.isReg === 0) {
          if (this.isLogin) {
            this.type = 3;
          } else {
            this.type = 2;
          }
        }
        Cookies.set("SSO_TOKEN", val.data.token, {
          domain: ".sgsonline.com.cn",
          expires: 7
        });
        if (this.type === 1 || this.type === 2 || this.type === 3) {
          this.countdownTimer = setInterval(() => {
            if (this.countdownTime > 1) {
              this.countdownTime--;
            } else {
              clearInterval(this.countdownTimer);
              if (this.type !== 4) {
                window.location.href = "/quote/list";
              }
            }
          }, 1000);
        }
        this.dialogCode.visible = false;
        this.isSuccess = true;
      } else if (val.resultCode === "9978") {
        Cookies.remove("SSO_TOKEN", { domain: ".sgsonline.com.cn" });
        this.dialogCode.visible = true;
      } else {
        this.$message.error(val.resultMsg);
      }
    },
    // 关闭注册协议
    setTipsVisible(val) {
      this.dialogReg.visible = val;
    },
  },
  mounted() {
    qryCity({}, this.host.nodeUrl).then((res) => {
      for (var i = 0; i < res.data.length; i++) {
        res.data[i].citys = null;
      }
      this.provice = res.data || [];
    });
  },
  watch: {
    defaultForm: {
      handler(val) {
        if (val) {
          this.form = Object.assign(this.form, val)
        }
      },
      immediate: true
    },
    userInfo: {
      handler(val) {
        if (val) {
          this.form.customer = val.userNick;
          this.form.phone = val.userPhone;
          this.form.email = val.userEmail;
          // this.form.provice = val.provice
          if (val.userId) {
            this.isLogin = true;
            this.contact_approve_show = false;
          }
          // 登录后如果邮箱和手机有值，禁用输入框
          if (val.userPhone) this.disablePhone = true
          if (val.userEmail) this.disableMail = true
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss">
@import "./../../assets/style/mixin.scss";

.ticketInset {
  width: 345px;
  background: #ffffff;
  box-shadow: 0px 7px 10px 0px rgba(0, 0, 0, 0.12);
  padding-bottom: 5px;
  z-index: 99;

  .el-form-item {
    margin-bottom: 12px !important;
    border: none !important;
    padding-bottom: 0px !important;
  }

  .el-form-item__label {
    line-height: 20px;
    padding: 0 12px 7px 0;
    font-weight: normal;
    font-size: 14px !important;
  }

  .el-form-item__error {
    padding-top: 1px;
  }

  .el-input {
    height: 32px;
    line-height: 32px;
  }

  .el-input-group__prepend {
    border: 0;
    background: #f2f2f2;
  }

  .side_line {
    width: 100%;
    height: 4px;
    background: #ff6600;

    &.step {
      width: 317px;
    }
  }

  .side_wrap {
    padding: 0 28px 0 27px;

    h2 {
      font-size: 18px;
      color: #333;
      padding-top: 22px;
      margin: 0;
    }

    p.des {
      color: #f60;
      font-size: 14px;
      padding: 10px 0 15px 0;
    }

    input {
      background: #f2f2f2;
      height: 32px;
      border: none;
      font-family: Roboto, "Helvetica Neue", Arial, Helvetica, "PingFang SC",
        "Hiragino Sans GB", "Heiti SC", "Microsoft YaHei", "WenQuanYi Micro Hei",
        sans-serif;
    }

    textarea {
      background: #f2f2f2;
      border: none;
      font-family: Roboto, "Helvetica Neue", Arial, Helvetica, "PingFang SC",
        "Hiragino Sans GB", "Heiti SC", "Microsoft YaHei", "WenQuanYi Micro Hei",
        sans-serif;
    }

    .side_tab {
      height: 18px;
      margin-top: 10px;
      margin-bottom: 0 !important;

      span {
        display: inline-block;
        width: 75px;
        height: 26px;
        text-align: center;
        line-height: 26px;
        font-size: 14px;
        color: #a6a6a6;
        background: #fff;
        border-radius: 4px 4px 0px 0px;
        cursor: pointer;

        &.active {
          color: #333;
          background: #f2f2f2;
        }
      }
    }

    .side_tips {
      padding: 0 !important;
      margin: 0 !important;

      * {
        padding: 0;
        margin: 0;
        color: $mainColorActive;
        height: 20px;
        line-height: 20px;
        font-size: 12px;
      }
    }

    a.button {
      margin-top: 6px;
      color: #fff;
      font-size: 18px;
      width: 290px;
      line-height: 42px;
      height: 42px;
      text-align: center;
      background: $mainColor;
      border-radius: 3px;
      display: block;
      cursor: pointer;

      &:hover {
        background: #f49000;
      }
    }

    .side_protocol {
      margin-bottom: 10px !important;
      display: flex;
      justify-content: center;
      align-items: center;
      padding-bottom: 20px;

      .el-checkbox {
        display: flex;
        align-items: center;
      }

      .el-checkbox__input {
        position: relative;
      }

      .el-checkbox__label {
        font-size: 12px;
      }

      a {
        color: $mainColor;

        &:hover {
          color: $mainColorActive;
        }
      }

      .is-checked .el-checkbox__label {
        color: #606266;
      }
    }
  }

  .side_success {
    padding: 0 28px 20px 27px;
    text-align: center;

    .side_success_email {
      width: 147px;
      height: 100px;
      padding-top: 32px;
    }

    .side_success_title {
      font-size: 22px;
      font-weight: bold;
      color: #333333;
      padding-top: 19px;
    }

    .side_success_des {
      font-size: 14px;
      color: #333333;
      padding-top: 23px;
      padding-bottom: 14px;
    }

    .side_success_ERcode {
      display: flex;
      justify-content: space-between;
      align-items: center;

      img {
        width: 78px;
        height: 80px;
      }

      p {
        width: 185px;
        font-size: 14px;
        color: #878787;
        line-height: 24px;

        i {
          color: #f60;
        }
      }
    }

    .side_success_userinfo {
      background: #f2f2f2;
      width: 300px;
      height: 40px;
      line-height: 40px;
      font-size: 14px;
      color: #000;
      margin-bottom: 20px;

      a {
        color: $mainColor;
      }
    }

    .side_success_tips {
      color: #878787;
      font-size: 14px;
      text-align: center;
      line-height: 24px;
      text-align: center;

      a {
        color: $mainColor;
        text-decoration: underline;
      }
    }

    .side_success_countdown {
      font-size: 14px;
      color: #999;
      margin-top: 10px;

      i {
        color: $mainColor;
      }
    }
  }

  .side_step {
    padding: 0 28px 0 27px;

    h2 {
      margin: 0;
      width: 155px;
      font-size: 16px;
      font-weight: bold;
      font-style: italic;
      color: #333333;
      background: url("./../../assets/images/ticketInset/arrow.png") no-repeat 0 center;
      padding-left: 20px;
      margin-top: 13px;
    }

    a.button {
      margin-top: 23px;
      color: #fff;
      font-size: 18px;
      width: 290px;
      line-height: 42px;
      height: 42px;
      text-align: center;
      background: $mainColor;
      border-radius: 3px;
      display: block;
      cursor: pointer;

      &:hover {
        background: #f49000;
      }
    }

    .side_step_gif {
      margin-top: 33px;
      width: 287px;
      height: 137px;
      border: 1px solid #d2d2d2;
      border-radius: 8px;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;

      span {
        position: absolute;
        width: 49px;
        height: 11px;
        font-size: 12px;
        color: #ddd;
        display: inline-block;
        top: -9px;
        left: 30px;
        background: #fff;
        padding: 0 3px;
      }
    }

    img {
      cursor: pointer;
    }

    a.more {
      padding-top: 13px;
      font-size: 12px;
      color: #000000;
      opacity: 0.5;
      display: block;
      text-align: right;
      padding-bottom: 20px;

      &:hover {
        color: $mainColor;
      }
    }
  }
}
</style>
